import { EMPTY_OBJECT } from 'commons-ui';

import { MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';

export const makeActionHandler = (action: any, params: any) => {
	const { rowData = EMPTY_OBJECT, history } = params;

	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.messageCenter}/create`
				});
			};
		case 'edit':
			return () => {
				history.push({
					pathname: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.messageCenter}/edit`,
					state: {
						rowData
					}
				});
			};

		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
